import "./index.css";
import { clsx } from "clsx";
import { useMemo } from "react";
import { Avatar } from "../Avatar";
import type { IAvatarStackAvatar, IAvatarStackProps } from "./types";

export const AvatarStack = ({
  avatars = [],
  size = "sm",
  shape = "round",
  className,
  loading,
  loadingCount = 5,
  maxVisible = 5,
}: IAvatarStackProps) => {
  const { visibleList, hiddenCount } = useMemo(() => {
    // Show one extra avatar rather than a "+1".
    const visibleCount =
      avatars.length <= maxVisible + 1 ? avatars.length : maxVisible;

    return {
      visibleList: avatars.slice(0, visibleCount),
      hiddenCount: avatars.length - visibleCount,
    };
  }, [avatars, maxVisible]);

  const list: IAvatarStackAvatar[] = loading
    ? Array(loadingCount).fill({})
    : visibleList;

  return (
    <div className={clsx("nuco-avatar-stack", className)}>
      {list.map((avatar: IAvatarStackAvatar, i: number) => (
        <Avatar
          key={i}
          {...avatar}
          className="nuco-avatar-stack__item"
          size={size}
          shape={shape}
          loading={loading}
          showDetails={false}
        />
      ))}
      {!loading && hiddenCount > 0 && (
        <Avatar
          className="nuco-avatar-stack__item"
          initials={`+${hiddenCount}`}
          size={size}
          shape={shape}
          showDetails={false}
        />
      )}
    </div>
  );
};
